import { render, staticRenderFns } from "./MenuDetailFooter.vue?vue&type=template&id=326101c3"
import script from "./MenuDetailFooter.vue?vue&type=script&lang=ts"
export * from "./MenuDetailFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports